function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#6C6D79",
  d: "M13.615 11l7.843-7.844A1.849 1.849 0 1 0 18.844.542L11 8.386 3.156.542A1.849 1.849 0 1 0 .541 3.156L8.385 11 .541 18.844a1.849 1.849 0 0 0 2.615 2.614L11 13.615l7.844 7.843a1.849 1.849 0 1 0 2.614-2.614L13.615 11z",
  opacity: 0.35
});

var SvgCloseIcon = function SvgCloseIcon(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICAgIDxwYXRoIGZpbGw9IiM2QzZENzkiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzLjYxNSAxMWw3Ljg0My03Ljg0NEExLjg0OSAxLjg0OSAwIDEgMCAxOC44NDQuNTQyTDExIDguMzg2IDMuMTU2LjU0MkExLjg0OSAxLjg0OSAwIDEgMCAuNTQxIDMuMTU2TDguMzg1IDExIC41NDEgMTguODQ0YTEuODQ5IDEuODQ5IDAgMCAwIDIuNjE1IDIuNjE0TDExIDEzLjYxNWw3Ljg0NCA3Ljg0M2ExLjg0OSAxLjg0OSAwIDEgMCAyLjYxNC0yLjYxNEwxMy42MTUgMTF6IiBvcGFjaXR5PSIuMzUiLz4KPC9zdmc+Cg==";
export { SvgCloseIcon as ReactComponent };